
import * as handlebars_family from "../handlebars_family.ts";
import "../widget/action-menu.ts";
const TPL = handlebars_family.addTemplate("mealplanner/recipeListFilter",{"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow><flexauto class=\"h1 flexrow\" data-widget=\"widget/action-menu\" data-autofill=\"true\" data-key=\"recipeFilter\" style=\"gap:8px\"></flexauto><icon data-widget=\"widget/action-menu\" data-key=\"recipeListMenu\" class=\"rounded-border\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_more_horizontal",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":251},"end":{"line":1,"column":283}}}))
    + "</icon></flexrow> ";
},"3":function(container,depth0,helpers,partials,data) {
    return " <flexrow data-widget=\"widget/action-menu\" data-autofill=\"true\" data-key=\"recipeFilter\" style=\"gap:8px\"></flexrow> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"nomenu") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":1},"end":{"line":1,"column":435}}})) != null ? stack1 : "")
    + " <input name=\"search\" type=\"search\" value=\"\" placeholder=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.search",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":493},"end":{"line":1,"column":520}}})) != null ? stack1 : "")
    + "\" style=\"flex:none;max-width:100%\" autocomplete=\"off\"> ";
},"useData":true});
export default TPL;